import React, { Suspense } from "react";

import { SpinnerFullScreen } from "../../components/SpinnerFullScreen";
import { IntegrationContextProvider } from "./context/integration-context";
import IntegrationRoute from "./IntegrationRoute";

// const Route = React.lazy(() => import("./IntegrationRoute"));

export const IntegrationRouteWithLazy: React.FC = () => {
  return (
    <Suspense fallback={<SpinnerFullScreen />}>
      <IntegrationContextProvider>
        <IntegrationRoute />
      </IntegrationContextProvider>
    </Suspense>
  );
};
